<template>
  <div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div style="font-size: 18px;padding-bottom: 20px">对应加能站停靠次数top100企业情况</div>
      <el-form :inline="true" :model="conditon">
        <el-form-item label="统计月份">
          <el-date-picker style="width: 150px;" v-model="conditon.time" type="month" placeholder="选择月" format="yyyy年MM月" value-format="yyyy-MM" @change="onChangeTime"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px;">
          <el-button @click="onPrev">返回上级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" :max-height="tableHeight + 80" stripe style="width: 100%">
      <el-table-column type="index" width="50" align="center" label="序号"></el-table-column>
      <el-table-column property="companyName" minWidth="180" label="停靠企业名称(掩码)" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.realCompanyName">{{ scope.row.realCompanyName }}</span>
          <el-tooltip v-else placement="top" content="点击解密">
            <span style="cursor: pointer" @click="onDecrypt(scope.row.id, scope.$index)">{{
                scope.row.companyName
              }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column property="companyAddress" minWidth="200" label="地址" align="center"></el-table-column>
      <el-table-column property="stopCount" label="全部车辆停靠次数(次)" align="center"></el-table-column>
      <el-table-column property="dieStopCount" label="柴油车辆停靠次数(次)" align="center"></el-table-column>
      <el-table-column property="lngStopCount" label="LNG车辆停靠次数(次)" align="center"></el-table-column>
      <el-table-column property="eleStopCount" label="电车辆停靠次数(次)" align="center"></el-table-column>
      <el-table-column property="hydStopCount" label="氢车辆停靠次数(次)" align="center"></el-table-column>
      <el-table-column property="otherStopCount" label="其他车辆停靠次数(次)" align="center"></el-table-column>
      <el-table-column property="companyCarNumLevel" label="企业总车辆区间" align="center"></el-table-column>
      <el-table-column property="dieStopRatio" label="柴油车辆占比" align="center"></el-table-column>
      <el-table-column property="lngStopRatio" label="LNG车辆占比" align="center"></el-table-column>
      <el-table-column property="eleStopRatio" label="电车辆占比" align="center"></el-table-column>
      <el-table-column property="hydStopRatio" label="氢车辆占比" align="center"></el-table-column>
      <el-table-column property="otherStopRatio" label="其他车辆占比" align="center"></el-table-column>
<!--      -->
<!--      <el-table-column property="stopCount" label="停靠次数" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{format(scope.row.stopCount)}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column property="stopCarCount" label="停靠车辆数" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{format(scope.row.stopCarCount)}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column property="companyCarNumLevel" label="企业旗下总车辆数" align="center"></el-table-column>-->
    </el-table>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import moment from 'moment'

export default {
  props: {
    id: {
      type: [Number, String],
    },
    dimObj: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      conditon: {
        time: this.dimObj.year + '-' + this.dimObj.month
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    getData() {
      this.tableData = []
      http
        .getStopDetailTop100Company2({
          //   poiId: 11116940 || this.id,
          poiId: this.id,
          year: this.conditon.time
            ? this.conditon.time.split('-')[0]
            : moment().year(),
          month: this.conditon.time
            ? this.conditon.time.split('-')[1]
            : moment().format('MM'),
          sourceGastype: 0,
        })
        .then((e) => {
          if (e.code == 200) {
            this.tableData = e.data || []
          } else {
            this.tableData = []
          }
        })
    },
    onChangeTime() {
      this.getData()
    },
    onDecrypt(id, index) {
      http.getStopDetailTop100CompanyDecrypt2({ id }).then((r) => {
        if (r.code == 200) {
          this.$set(
            this.tableData[index],
            'realCompanyName',
            r.data.companyName
          )
        }
      })
    },
    onPrev() {
      this.$emit('on-close')
    },
  },
}
</script>
